export default {
  isLastStep: state => (state.steps.length - 1) == state.currentStep,
  isSecondStep: state => state.currentStep == state.secondStep,
  currentStepValueEmpty: (state, rootGetters) => {
    if (state.currentStep == 0) return rootGetters['basicInfo/emptyBasic']
    if (state.currentStep == 1) return rootGetters['address/emptyAddress']
    if (state.currentStep == 2) return rootGetters['formation/emptyFormation']
    if (state.currentStep == 3) return rootGetters['experience/emptyExperience']
    if (state.currentStep == 4) return rootGetters['language/emptyLanguage']
    if (state.currentStep == 5) return rootGetters['skill/emptySkill']
    return false; // Default for unhandled steps
  },

  current: ({ steps, currentStep }) => steps[currentStep],

  allowJump: ({ steps }) => steps.filter(step => step.title === "Revisão")[0].completed,

  getResumeStep: ({ steps }) => steps.filter(step => step.title === "Revisão")[0]
}
